var r="_",a="-",e=".",o="~";export{r as ITEMS_SEPARATOR,e as POINTS_SEPARATOR,o as POINT_SEPARATOR,a as ROUTES_SEPARATOR};
